import { Injectable } from '@angular/core';

import { ConfigPedidoTipoVenda, ConfigPedidoTipoVendaIndicador, getTipoVendaIndicador } from '../tipo-venda';
import { ConfigPedido } from '../config-pedido';
import { PedidoStatus } from '../../../../pedido/status/pedido-status';

@Injectable({
    providedIn: 'root'
})
export class ConfigPedidoUtilsService {
    /** Cria os tipos de vendas do pedido através dos tipos configurados informados */
    createTiposVenda(entities: ConfigPedidoTipoVenda[], editMode: boolean): ConfigPedidoTipoVendaIndicador[] {
        if (!entities) {
            return [];
        }

        const tiposVenda: ConfigPedidoTipoVendaIndicador[] = [];
        for (let i = 0; i < entities.length; i++) {
            const entity = entities[i];
            const tipoVenda = getTipoVendaIndicador(entity.tipoVenda);

            if (tipoVenda) {
                // Ignorando o tipo se estiver inserindo um novo pedido e não permitir selecionar este tipo na inserção
                if (!editMode && !entity.podeInserir) {
                    continue;
                }

                tiposVenda.push(tipoVenda);
            }
        }

        return tiposVenda;
    }

    /** Verifica se a configuração do pedido possui o status informado */
    possuiStatus(configPedido: ConfigPedido, status: PedidoStatus): boolean {
        if (!configPedido || !status) {
            return false;
        }

        const index = configPedido?.status?.findIndex(filter => filter.status === status.id);
        return index >= 0 ;
    }
}
